import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';

import { default as Actions } from '../actions';
import * as CommonActions from '../../common/actions';

import * as Util from '../../common/utilities';

import { BrandBand, WelcomeMatContainer } from '../../common/components';
import { Header, McMenu } from '../components/';
import {
  Button,
  Card,
  PageHeaderControl,
  Popover,
  Spinner,
  Tabs as TabContainer,
  TabsPanel
} from '@salesforce/design-system-react';
import * as Tabs from './tabs';

import './ContentSelectionRoot.scss';
import { Link } from 'react-router-dom';

export class ContentSelectionRoot extends Component {
  constructor(props) {
    super(props);
    this.buildTab = this.buildTab.bind(this);
    this.selectionBrowserButton = this.selectionBrowserButton.bind(this);
    this.state = {
      isLoading: true,
      selectedIndex: undefined,
      selectedTab: undefined,
      isPopoverDismissed: Boolean(
        localStorage.getItem('selectionBrowserPopoverDismissed')
      ),
      isWeatherPopoverDismissed: false
    };
  }

  componentDidMount() {
    // TODO: can we bootstrap what we need with fewer API calls?
    this.props.actions.getAssetTypes();
    this.props.actions.getAssetAttributes();
    this.props.actions.getAssetSummary();
    this.props.actions.getAssetDistributionByKey('type');
    this.props.actions.getAttributes();
    this.props.actions.getRules();
  }

  componentDidUpdate(prevProps) {
    if (
      Util.propChanged(
        prevProps,
        this.props,
        'assets.isLoadingAssetTypes',
        false
      )
    ) {
      if (this.props.assets.hasLoadedOnce) {
        if (!this.hasData() && !this.uploadSkipped()) {
          this.props.history.push('/welcome');
        } else {
          this.setState({ isLoading: false });
        }
      }
    }
  }

  showSettingsWeatherTooltip() {
    const { rules } = this.props.rules?.data;
    return rules?.settings?.weather && rules?.location_mapping === null;
  }

  buildTab(tab) {
    const { formatMessage } = this.props.intl;
    if (tab.key === 'settings' && this.showSettingsWeatherTooltip()) {
      return (
        <TabsPanel key={`tab-${tab.key}`} label={tab.label}>
          <Popover
            className="weather-popover"
            variant="feature"
            body={
              <div>
                <p>
                  {formatMessage({
                    id: 'components.ecs.advancedSettings.weatherTooltip'
                  })}
                </p>
              </div>
            }
            position="overflowBoundaryElement"
            align="bottom"
            onRequestTargetElement={() => {
              return document.querySelector(
                '.content-selection-tab-container > ul > li:nth-of-type(3)'
              );
            }}
            triggerClassName="weather-tooltip"
            isOpen={!this.state.isWeatherPopoverDismissed}
            onRequestClose={() => {
              this.setState({ isWeatherPopoverDismissed: true });
            }}
          >
            <tab.component {...this.props} />
          </Popover>
        </TabsPanel>
      );
    } else {
      return (
        <TabsPanel key={`tab-${tab.key}`} label={tab.label}>
          <tab.component {...this.props} />
        </TabsPanel>
      );
    }
  }

  selectionBrowserButton() {
    const { formatMessage } = this.props.intl;
    const selectionLearnLink =
      'https://help.salesforce.com/articleView?id=sf.mc_pb_find_out_why_an_asset_was_selected.htm&type=5';
    const button = (
      <Link to={{ pathname: '/selections' }}>
        <Button id="view-selections" variant="neutral">
          <FormattedMessage id="components.ecs.analytics.header.button.label" />
        </Button>
      </Link>
    );

    const selectionBrowserButton = localStorage.getItem(
      'selectionBrowserPopoverDismissed'
    ) ? (
      button
    ) : (
      <Popover
        className="selection-browser-popover"
        variant="feature"
        align="bottom right"
        heading={formatMessage({
          id: `components.ecs.analytics.header.button.popoverHeader`
        })}
        body={
          <div>
            <p>
              {formatMessage({
                id: `components.ecs.analytics.header.button.popoverText`
              })}
            </p>
          </div>
        }
        footerWalkthroughActions={
          <Button
            onClick={event => {
              window.open(selectionLearnLink, '_blank', 'noopener noreferrer');
            }}
            variant="neutral"
          >
            {formatMessage({
              id: `components.ecs.analytics.header.button.popoverCTA`
            })}
          </Button>
        }
        isOpen={!this.state.isPopoverDismissed}
        onRequestClose={() => {
          this.setState({ isPopoverDismissed: true });
          localStorage.setItem('selectionBrowserPopoverDismissed', true);
        }}
        {...this.props}
      >
        {button}
      </Popover>
    );

    return () => (
      <PageHeaderControl>{selectionBrowserButton}</PageHeaderControl>
    );
  }

  renderWelcomeMat() {
    return <WelcomeMatContainer name="ecs" {...this.props} />;
  }

  hasData() {
    return this.props.assets.data.types.length;
  }

  uploadSkipped() {
    return localStorage.getItem('userSkippedUpload');
  }

  renderSpinner() {
    return (
      <div className="spinner-container">
        <Spinner variant="brand" />
      </div>
    );
  }

  render() {
    const { formatMessage } = this.props.intl;
    const defaultTab = this.props.match?.params?.tab || 'distribution';
    const tabs = [
      {
        label: formatMessage({ id: 'components.ecs.nav.analytics' }),
        key: 'analytics',
        component: Tabs.AnalyticsTab
      },
      {
        label: formatMessage({ id: 'components.ecs.nav.distribution' }),
        key: 'distribution',
        component: Tabs.DistributionTab
      },
      {
        label: formatMessage({ id: 'components.ecs.nav.settings' }),
        key: 'settings',
        component: Tabs.SettingsTab
      }
    ];

    let headerActions;
    if (
      this.state.selectedIndex === 0 ||
      (defaultTab === 'analytics' && this.state.selectedIndex === undefined)
    ) {
      headerActions = this.selectionBrowserButton();
    }

    return (
      <McMenu
        flags={this.props.flags}
        history={this.props.history}
        route="/root"
      >
        <BrandBand>
          <Header route={this.props.match} onRenderActions={headerActions} />
          <Card className="content-selection-root-card" hasNoHeader>
            {this.state.isLoading ? (
              this.renderSpinner()
            ) : (
              <TabContainer
                className="content-selection-tab-container"
                defaultSelectedIndex={tabs.findIndex(t => t.key === defaultTab)}
                onSelect={selectedIndex => {
                  this.props.history.replace(
                    `/root/${tabs[selectedIndex].key}`
                  );
                  this.setState({
                    selectedIndex,
                    selectedTab: tabs[selectedIndex]
                  });
                }}
                selectedIndex={this.state.selectedIndex}
              >
                {tabs.map(this.buildTab)}
              </TabContainer>
            )}
          </Card>
          {this.renderWelcomeMat()}
        </BrandBand>
      </McMenu>
    );
  }
}

ContentSelectionRoot.contextTypes = {
  router: PropTypes.object
};

ContentSelectionRoot.propTypes = {
  assets: PropTypes.object,
  attributes: PropTypes.object,
  actions: PropTypes.object,
  flags: PropTypes.object,
  modals: PropTypes.object,
  location: PropTypes.object
};

function mapStateToProps(state) {
  const { ecs, welcomeMat, ...others } = state;
  return {
    flags: state.ecs.flags,
    ...ecs,
    welcomeMat: welcomeMat.ecs,
    ...others
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...Actions, ...CommonActions }, dispatch)
  };
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(ContentSelectionRoot)
);
